import React from "react";

function BookingPage() {
  
  return (
    <div>
      <h1>Bookings</h1>
      <p>Insert your booking form or details here...</p>
    </div>
  );
}

export default BookingPage;
